const initialState = {
  actionMenu: { isOpen: false }
}
const actions = {
  togleActionMenu({ commit, state }) {
    commit('setActionMenu', !state.actionMenu.isOpen)
  }
}
const mutations = {
  setActionMenu(state, newState) {
    state.actionMenu.isOpen = newState
  }
}

export const gadget = {
  namespaced: true,
  state: initialState,
  actions,
  mutations
}
